"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Command Response
exports.RESPONSE_STATUS_SUCCESS = 'success';
exports.RESPONSE_STATUS_ERROR = 'error';
exports.RESPONSE_STATUS_UNKNOWN = 'unknown';
